/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { useColor } from '../theme/_hooks/colors'

const size = 1.3
const innerSize = size - 0.5

const Marker = ({ color, circle, value, onChange, disabled }) => {
  if (!value) color = COLORS.light3
  if (!!disabled) color = COLORS.light2
  const colorValue = useColor(color, 'primary')

  const style = css`
    border: solid 1px ${color};
    border-radius: 2px;
    height: ${size}rem;
    width: ${size}rem;
    ${circle ? `border-radius: ${size}rem;` : ''}
    display: flex;
    align-items: center;
    justify-content: center;

    & > .innerCircle {
      opacity: ${value ? 1 : 0};
      border-radius: 2px;
      background-color: ${colorValue};
      ${circle ? `border-radius: ${size}rem;` : ''}
      width: ${innerSize}rem;
      height: ${innerSize}rem;
    }
  `

  const handleChange = () => {
    if (!!disabled) return
    onChange && onChange(!value)
  }

  return (
    <div className="circle" css={style} onClick={handleChange}>
      <div className="innerCircle"></div>
    </div>
  )
}

export const Checkbox = Marker
export const Radio = props => <Marker {...props} circle />

export default Marker
